import JourneysList from './JourneysList';

export default JourneysList;
